import { ref } from '@vue/runtime-core';
import { manageModalPosition, convertEditableDomToText } from '../utils/helper';
export function useGenerate() {
    let initeText = '<div></div>';
    for (let i = 0; i < 40; i++) {
        initeText += '<div></div>';
    }
    //題材を元にテキストを作るモーダル
    const initModal = ref(false);
    //アレンジモーダル
    const arrangeModal = ref(false);
    // テキストエリアの値を取得
    const writeText = ref(initeText);
    // 生成中かどうか
    const isGeneratePending = ref(false);
    // 生成されているテキストを表示するモーダルの表示状態
    const isGenerateModalOpen = ref(false);
    //生成されたテキスト
    const generatedText = ref('');
    //選択中かどうか
    const isSelecting = ref(false);
    //選択中のテキスト
    const selectedText = ref('');
    //選択した範囲
    const selectedRange = ref(null);
    const selectedPrompt = ref(0);
    const openInitModal = () => {
        initModal.value = true;
    };
    const closeInitModal = () => {
        initModal.value = false;
    };
    //アレンジモーダルを表示
    const openArrangeModal = () => {
        const before = document.getElementById('js-before-preview');
        const text = document.getElementById('text');
        if (!before || !text)
            throw new Error('要素が見つかりません');
        const texts = convertEditableDomToText(text);
        if (texts.trim() === '') {
            alert('テキストが入力されていません');
            return;
        }
        arrangeModal.value = true;
        before.innerText = texts;
    };
    //アレンジモーダルを非表示
    const closeArrangeModal = () => {
        arrangeModal.value = false;
    };
    //テキストエリアのテキストが選択された時、指示モーダルを表示する
    const setPromptModal = (text) => {
        selectedText.value = text;
        isSelecting.value = true;
    };
    //指示モーダル非表示
    const closePromptModal = () => {
        isSelecting.value = false;
        selectedText.value = '';
    };
    //生成中のモーダルを表示
    const openGenerateModal = () => {
        isGenerateModalOpen.value = true;
        isGeneratePending.value = true;
    };
    //生成完了
    const completeGenerate = () => {
        isGeneratePending.value = false;
    };
    const closeGenerateModal = () => {
        isGenerateModalOpen.value = false;
        isGeneratePending.value = false;
        generatedText.value = '';
    };
    //選択完了後に指示モーダルを表示するする
    const handleMouseUp = (scrollable, promptModalId) => {
        setTimeout(() => {
            const selection = window.getSelection();
            if (selection && selection.rangeCount > 0 && selection.toString().trim().length > 0) {
                console.log('selected', selection.toString().trim());
                const selected = selection.getRangeAt(0);
                const range = selected.getBoundingClientRect();
                selectedRange.value = selected;
                const modal = document.getElementById(promptModalId);
                if (!modal)
                    throw new Error('指示モーダルが見つかりません');
                //選択範囲の下にモーダルを表示
                manageModalPosition(scrollable, modal, range, { top: true, left: true });
                //指示モーダルを表示
                setPromptModal(selection.toString());
                // //promptModalを表示する(idがpromptModalIdの要素を表示する)
                const windowHeight = window.innerHeight;
                const selectionMiddle = (range.top + range.bottom) / 2;
                const middlePosition = selectionMiddle - windowHeight / 2;
                // 新しいスクロール位置をビューポートの中心に選択範囲が来るように設定
                const newScrollTop = middlePosition + scrollable.scrollTop;
                scrollable.scrollTo({
                    top: newScrollTop, // 調整されたスクロール位置を設定
                    behavior: 'smooth'
                });
            }
            else {
                closePromptModal();
            }
        }, 10);
    };
    return {
        initModal,
        arrangeModal,
        writeText,
        isGeneratePending,
        isGenerateModalOpen,
        generatedText,
        isSelecting,
        selectedText,
        selectedRange,
        selectedPrompt,
        openInitModal,
        closeInitModal,
        openArrangeModal,
        closeArrangeModal,
        setPromptModal,
        closePromptModal,
        openGenerateModal,
        completeGenerate,
        closeGenerateModal,
        handleMouseUp,
    };
}
